import { format } from 'app/shared/StatFormatting';
import Constants from 'app/shared/utilities/constant';

export class VisibleRadio {
    _visibleRadio;

    constructor(visibleRadio) {
        this._visibleRadio = visibleRadio;
    }

    get isNextHop() {
        return this._visibleRadio.is_next_hop;
    }

    get mac() {
        return this._visibleRadio.mac;
    }

    get rssi() {
        return this._visibleRadio.rssi;
    }

    get cost() {
        return this._visibleRadio.cost;
    }

    get txRate() {
        return this._visibleRadio.tx_rate;
    }

    get formatted(): { rssi: string; txRate: string } {
        return {
            rssi: format.rssi(this.rssi),
            txRate: format.megabitrate(this.txRate, Constants.UNITS.BITRATE),
        };
    }
}
